$('.dropdown').each(function() {
	var children = $(this).children();

	if(children.length > 8) {
		$(this).addClass('dropdown-menu-grid');
	}else {
		$(this).removeClass('dropdown-menu-grid');
	}
});